export default __webpack_public_path__ + "static/media/root_game.ab66fa2f.png";